import { Platform, StyleSheet } from 'react-native';

export default StyleSheet.create({
    checkboxContainer: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'center'
    },
    checkboxText: {
        color: '#707070',
        fontFamily: 'GothamMedium',
        fontSize: Platform.OS.equals('web') ? '12pt' : 12,
        textAlign: 'center'
    },
    errorStyle: {
        color: '#8B0000',
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '12pt' : 12
    },
    introductionIconText: {
        color: 'rgb(93, 110, 127)',
        display: !Platform.OS.equals('web') ? 'flex' : undefined,
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '12pt' : 12,
        justifyContent: !Platform.OS.equals('web') ? 'center' : undefined,
        padding: !Platform.OS.equals('web') ? 0 : 20
    },
    introductionText: {
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '14pt' : 14,
        color: 'rgb(93, 110, 127)',
        padding: !Platform.OS.equals('web') ? 0 : 20
    },
    selectFieldInputText: {
        color: 'rgb(93, 110, 127)',
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '12pt' : 12
    },
    smallInputStyle: {
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '12pt' : 12,
        minHeight: !Platform.OS.equals('web') ? undefined : 40,
        paddingLeft: 10
    },
    validSmallInputStyle: {
        borderBottomColor: '#008000',
        borderBottomWidth: 0.35,
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '12pt' : 12,
        paddingLeft: 10
    },
    placeholderStyle: {
        color: 'rgb(93, 110, 127)',
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '12pt' : 12
    },
    resendConfirmationText: {
        color: '#153d6e',
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '12pt' : 12,
        fontWeight: 800,
        marginBottom: 10
    },
    stepButtonContainer: {
        boxShadow: undefined,
        flex: 1,
        marginHorizontal: 10,
        marginVertical: 10
    },
    stepButton: {
        backgroundColor: '#153d6e',
        paddingHorizontal: 10
    },
    stepButtonTitle: {
        color: '#fff',
        fontFamily: 'GothamMedium',
        fontSize: Platform.OS.equals('web') ? '20pt' : 20,
        textTransform: 'uppercase'
    },
    disabledStepButton: {
        backgroundColor: '#8897a2',
        opacity: 0.4
    },
    disabledStepButtonTitle: {
        color: '#fff',
        fontFamily: 'GothamMedium',
        fontSize: Platform.OS.equals('web') ? '20pt' : 20,
        textTransform: 'uppercase'
    },
    previousStepButtonContainer: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        width: '100%'
    },
    previousStepButtonTitle: {
        color: '#153d6e',
        fontFamily: 'GothamMedium',
        fontSize: Platform.OS.equals('web') ? '12pt' : 12
    },
    alternateActionText: {
        color: '#a61a2b',
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '14pt' : 14
    }
});
